import React from "react";
import SvgIcon from "@mui/material/SvgIcon";

export default function SkuflixSpeedIcon(props) {
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      <path
        d="M12 12.1921L15.7145 8.33594"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M17.3668 19.5809C18.9966 18.4269 20.2111 16.7783 20.83 14.8796C21.449 12.9809 21.4394 10.9333 20.8027 9.04047C20.1661 7.14764 18.9363 5.51044 17.2958 4.3717C15.6552 3.23297 13.6913 2.65337 11.6953 2.71887C9.69939 2.78437 7.77771 3.49149 6.21536 4.73534C4.653 5.97918 3.53318 7.6935 3.02202 9.624C2.51085 11.5545 2.63556 13.5983 3.37765 15.4524C4.11974 17.3064 5.43968 18.8719 7.14168 19.9165"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        fill="none"
      />
    </SvgIcon>
  );
}
